import React, { Component } from 'react'
import './styles.scss'
import { Link } from 'react-router-dom'
import { withTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { Col, Hidden, Visible } from '../../Shared/Grid'
import PropTypes from 'prop-types'
import { getName } from '../../../item'
import LanguageChanger from '../../Shared/LanguageChanger'

class Header extends Component {

  renderLanguageChanger (path) {
    switch (path) {
      case '/order/landing':
      case '/hotel-chain':
        return null
      case '/checkout':
      case '/order/confirm':
      case  '/item/:id':
        return <Visible xs sm md><LanguageChanger/></Visible>
      default:
        return <Visible xs sm><LanguageChanger/></Visible>
    }
  }

  render () {
    const { t } = this.props
    return (
      <header className="mygiata_header">
        <div className="mygiata_header_top">
          {this.props.match.path === '/' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={8} sm={4}>
                <div className={'header-nav-content-centered'}>
                  <div className={'header-nav-wizard'}>
                    <div className={'header-nav-wizard-content'}>
                      <a href="https://www.giata.com/en/giata-drive-en/" target={'_blank'} rel={'noreferrer'}> <i
                        className="fa fa-info"
                        aria-hidden="true"/> {t("DETAILS_ABOUT_PRODUCT")}</a>
                    </div>
                  </div>
                </div>
              </Col>
              <Col xs={4}>
                <div className={'header-nav-content-right'}>
                  <div className={'nav-content-page-desc'}>
                    <Hidden xs sm>
                      <LanguageChanger/>
                    </Hidden>
                  </div>
                </div>
              </Col>
            </div>
          }
          {this.props.match.path === '/hotel-chain' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={4}/>
              <Col xs={4}>
                <div className={'header-nav-content-right'}>
                  <div className={'nav-content-page-desc'}>
                    <LanguageChanger/>
                  </div>
                </div>
              </Col>
            </div>
          }
          {this.props.match.path === '/search' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={8} sm={4}>
                <div className={'header-nav-content-centered'}>
                  <div className={'header-nav-wizard'}>
                    <div><Link to={'/'}>
                      <div className="arrow-left"/>
                    </Link></div>
                    <div className={'header-nav-wizard-content'}>{t('PAGE_SEARCH')}</div>
                    <div><span onClick={() => {
                      if (this.props.cartItems.length > 0) {
                        this.props.history.push('/item/' + this.props.cartItems[0].id)
                      }
                    }
                    }><div className="arrow-right"/></span></div>
                  </div>
                </div>
              </Col>
              <Hidden xs sm>
                <Col xs={4}>
                  <div className={'header-nav-content-right'}>
                    <div className={'nav-content-page-desc'}>
                      <LanguageChanger/>
                    </div>
                  </div>
                </Col>
              </Hidden>
            </div>
          }
          {this.props.match.path === '/item/:id' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={8} sm={8} md={4}>
                <div className={'header-nav-content-centered'}>
                  {this.props.currentItem &&
                    <div className={'header-nav-wizard'}>
                      <div><Link to={'/search'}>
                        <div className="arrow-left"/>
                      </Link></div>
                      <div
                        className={'header-nav-wizard-content'}>{getName(this.props.currentItem, this.props.i18n.language)}</div>
                      <div><span onClick={() => {
                        if (this.props.cartItems.length > 0) {
                          this.props.history.push('/checkout')
                        }
                      }
                      }><div className="arrow-right"/></span></div>
                    </div>
                  }
                </div>
              </Col>
              <Hidden xs sm md>
                <Col xs={4}>
                  <div className={'header-nav-content-right'}>
                    <div className={'nav-content-page-desc'}>
                      <LanguageChanger/>
                    </div>
                  </div>
                </Col>
              </Hidden>
            </div>
          }
          {this.props.match.path === '/checkout' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={8} sm={8} md={4}>
                <div className={'header-nav-content-centered'}>
                  {
                    this.props.cartItems.length > 0 &&
                    <div className={'header-nav-wizard'}>
                      <div><Link to={'/item/' + this.props.cartItems[0].id}>
                        <div className="arrow-left"/>
                      </Link></div>
                      <div
                        className={'header-nav-wizard-content'}>{this.props.cartItems[0].payload.name}</div>
                      <div><Link to={'/order/confirm/'}>
                        <div className="arrow-right"/>
                      </Link></div>
                    </div>
                  }
                </div>
              </Col>
              <Hidden xs sm md>
                <Col xs={4}>
                  <div className={'header-nav-content-right'}>
                    <div className={'nav-content-page-desc'}>
                      <LanguageChanger/>
                    </div>
                  </div>
                </Col>
              </Hidden>
            </div>
          }
          {this.props.match.path === '/order/confirm' &&
            <div className="header-nav-content">
              <Col xs={4}/>
              <Col xs={8} sm={8} md={4}>
                <div className={'header-nav-content-centered'}>
                  {
                    this.props.cartItems.length > 0 &&
                    <div className={'header-nav-wizard'}>
                      <div><Link to={'/checkout/'}>
                        <div className="arrow-left"/>
                      </Link></div>
                      <div
                        className={'header-nav-wizard-content'}>{this.props.cartItems[0].payload.name}</div>
                      <div><Link to={'/order/confirm/'}>
                        <div className="arrow-right"/>
                      </Link></div>
                    </div>
                  }
                </div>
              </Col>
              <Hidden xs sm md>
                <Col xs={4}>
                  <div className={'header-nav-content-right'}>
                    <div className={'nav-content-page-desc'}>
                      <LanguageChanger/>
                    </div>
                  </div>
                </Col>
              </Hidden>
            </div>
          }
          {this.props.match.path === '/order/landing' &&
            <div className="header-nav-content">
              <Col xs={12}>
                <div className={'header-nav-content-right'}>
                  <div className={'nav-content-page-desc'}>
                    <LanguageChanger/>
                  </div>
                </div>
              </Col>
            </div>
          }
          <Link to="/" className="mygiata_logo"/>
        </div>
        <div>
          {this.renderLanguageChanger(this.props.match.path)}
        </div>
      </header>
    )
  }
}

Header.propTypes = {
  currentItem: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    cartItems: state.cart.items
  }
}

const mapDispatchToProps = () => {
  return {}
}

export default withRouter(withTranslation()(connect(mapStateToProps, mapDispatchToProps)(Header)))
